<script>
import { Select } from 'element-ui';

export default {
  extends: Select,
  data: () => ({
    isAbUser: false,
  }),
  computed: {
    bgcolor() {
      return this.isAbUser ? 'transparent' : '#097FB5';
    },
    carretcolor() {
      return this.isAbUser ? '#097FB5' : '#FFFFFF';
    },
    iconClass() {
      return this.visible ? 'arrow-up is-reverse' : 'arrow-up';
    },
  },
  methods: {
    handleFocus(event) {
      if (!this.softFocus) {
        if (this.automaticDropdown || this.filterable) {
          if (this.filterable && !this.visible) {
            this.menuVisibleOnFocus = true;
          }
          this.visible = true;
        }
        this.$emit('focus', event);
        this.dispatch('ElFormItem', 'el.form.input.focus');
      } else {
        this.softFocus = false;
      }
    },
    handleBlur(event) {
      setTimeout(() => {
        if (this.isSilentBlur) {
          this.isSilentBlur = false;
        } else {
          this.$emit('blur', event);
          this.dispatch('ElFormItem', 'el.form.input.blur');
        }
      }, 50);
      this.softFocus = false;
    },

  },
  mounted() {
    this.$posthog?.onFeatureFlags(() => {
      if (this.$posthog?.getFeatureFlag('select-color') === 'test') {
        this.isAbUser = true;
      } else {
        this.isAbUser = false;
      }
    });
  },
};
</script>

<style lang="scss">
.el-select {
  display: block;

  .el-tag--info {
    color: $--color-primary;
    border-color: $--color-gray-2;
    background-color: $--color-gray-7;

    .el-tag__close {
      color: $--color-primary;
    }
  }
  .el-input {
    .el-select__caret {
      color: v-bind(carretcolor);
    }
  }

  .el-input__inner {
    padding-right: rem(25px);
    font-weight: 500;
  }

  .el-input__suffix {
    width: rem(32px);
    right: 0;
    background-color: v-bind(bgcolor);
    border-radius: 0 4px 4px 0;

    .el-input__icon {
      font-weight: 700;
    }
  }
}

.el-select-dropdown {
  max-width: 100%;

  &.el-popper {
    margin: 0;
  }

  .popper__arrow {
    display: none;
  }
}

.el-select-dropdown__item {
  font-size: rem(13px);
  padding: rem(6px);
  line-height: 1;
  color: $--color-text-regular;

  &:hover,
  &.hover {
    color: $--color-white;
  }

  &.selected {
    background-color: $--select-option-selected;
    color: $--color-text-regular;
  }

  &.selected.hover {
    background-color: $--color-primary;
    color: $--color-white;
  }
}

.el-select-dropdown.is-multiple {
  .el-select-dropdown__item {
    &.selected.hover {
      color: $--color-white;
      background-color: $--color-primary;
    }
  }
}
</style>

<style lang="scss" scoped>
.dropdown-steady {
  position: relative;

  .el-select-dropdown {
    position: absolute !important;
    top: 100% !important;
    left: 0 !important;
    transform-origin: top !important;
  }
}

.dropdown-steady--with-prefix,
.select-v2--with-prefix {
  :deep() {
    .el-select-dropdown__item {
      display: flex;
      align-items: center;
      gap: 3px;
    }

    .el-input__prefix {
      display: inline-flex;
      align-items: center;
      width: auto;
      padding: 0 rem(7px);
    }

    .el-input__inner {
      padding-left: rem(56px);
    }
  }
}

.select-v2--with-prefix {
  :deep() {
    .el-input__prefix {
      padding-left: rem(9px);
    }
  }
}

.select-v2 {
  position: relative;

  .el-select-dropdown {
    position: absolute !important;
    top: 100% !important;
    left: 0 !important;
    transform-origin: top !important;
  }

  .el-select-dropdown,
  &.el-select-dropdown {
    border-color: $blue-mist;
    border-radius: 8px;
    border-width: 1px;
  }

  :deep() {
    .el-input__suffix {
      background-color: transparent;

      .el-input__icon {
        color: $--color-primary;
      }
    }

    .el-scrollbar__bar {
      display: none;
    }

    .el-input__inner {
      font-weight: 600;
    }

    .el-select-dropdown__item {
      font-size: 1rem;
      padding: 8px 9px;
      margin: 7px;
      border-radius: 8px;

      &:hover,
      &.hover {
        background-color: $--color-primary;
        font-weight: 600;
      }

      &.selected {
        background-color: #f4f9fb;
        font-weight: 600;
      }

      &.selected.hover {
        background-color: $--color-primary;
        color: $--color-white;
      }
    }

    .el-input.is-disabled {
      .el-input__inner:disabled {
        cursor: not-allowed;
        color: $--color-text-blue;
        -webkit-text-fill-color: $--color-text-blue;
      }

      .el-input__suffix .el-input__icon {
        color: $--color-text-blue;
      }
    }
  }
}

.el-select--date {
  .date__wrapper {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .date__text {
    color: $--color-text-blue;
    font-size: 14px;
  }

  .calendar-icon {
    align-self: center;
    color: $--color-primary;
    font-size: 24px;
    height: 24px;
    line-height: 24px;
    vertical-align: middle;
  }
}

.el-select--custom-label {
  :deep() {
    .el-input-group__prepend {
      background-color: $--color-white;
      border-radius: 8px;
      border: 1px solid $--border-color-base;
      color: $--color-text-primary;
      cursor: pointer;
      display: block;
      font-weight: 600;
      padding-left: 12px;
      padding-right: 25px;
      width: 100%;
    }
  }

  &:hover,
  &:focus,
  & .el-input.is-focus {
    :deep() {
      .el-input-group__prepend {
        border-color: $--color-primary;
      }
    }
  }

  .el-select__custom-label {
    display: flex;
    align-items: normal;
    gap: 4px;
    line-height: 38px;
    max-height: 38px;
    user-select: none;
  }
}
</style>
